import { handleActions } from 'redux-actions';
import { yyyymmdd } from '@/utils/date';
import mainTypes from '@/actions/mainTypes';
import types from '@/actions/outsideTypes';

const initialState = {
  startHour: 0,
  startMinute: 0,
  endHour: 0,
  endMinute: 0,
  startDate: yyyymmdd(new Date()),
  endDate: yyyymmdd(new Date()),
  desc: '',
  outsideList: [],
  isOpenModal: false
};

/* Reducer */
export default handleActions({
  [mainTypes.UPDATE_EMPNO]: (state, action) => {
    return { ...state,
      outsideList: []
    }
  },
  [types.SET_OUTSIDE_DATA]: (state, action) => {
    return { ...state,
      outsideList: action.data
    }
  },
  [types.UPDATE_INPUT_VALUE]: (state, action) => {
    const newState = { ...state,
      [action.key]: action.value
    }
    if (action.key === 'startDate') {
      newState.endDate = action.value
    }
    return newState;
  },
  [types.SAVE_OUTSIDE_DATA]: (state, action) => {
    return { ...state,
      startHour: 0,
      startMinute: 0,
      endHour: 0,
      endMinute: 0,
      desc: ''
    }
  },
  [types.OPEN_MODAL]: (state, action) => {
    return { ...state,
      isOpenModal: true
    }
  },
  [types.CLOSE_MODAL]: (state, action) => {
    return { ...state,
      isOpenModal: false
    }
  },
}, initialState);


// WEBPACK FOOTER //
// ./src/reducers/outsideReducer.js